import "./style.moduleRenamed.css";

export const compSelectorHintItem = "style-module__compSelectorHintItem___xIUZZ";
export const isScopeRoot = "style-module__isScopeRoot___s01cr";
export const toolBtn = "style-module__toolBtn___hc11c";
export const compSelectorInput = "style-module__compSelectorInput___UUtFg";
export const captureFromPage = "style-module__captureFromPage___Qb-1V";

export default {
  compSelectorHintItem: "style-module__compSelectorHintItem___xIUZZ",
  isScopeRoot: "style-module__isScopeRoot___s01cr",
  toolBtn: "style-module__toolBtn___hc11c",
  compSelectorInput: "style-module__compSelectorInput___UUtFg",
  captureFromPage: "style-module__captureFromPage___Qb-1V",
};